$(document).ready(function () {
  $("#my-cart").click(function(){    

    // setTimeout(function() {
    // $("#nt_cart_canvas").removeClass("act_opened"); 
    // $("html").removeClass("hside_opened");
    //  $("body").removeClass("pside_opened");
    // $(".mask-overlay").css("display", "none");
    // }, 3000);

    });
});
